module.exports = "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/api.57920cd5.svg";